// Memorial entry for Inbar Haiman
import inbarHaimanPortrait from '../../../images/inbar-haiman.jpg';

export const inbarHaimanMemorial = {
  id: 37,
  name: 'Inbar Haiman',
  images: {
    portrait: inbarHaimanPortrait
  },
  info: `
"Rest in peace, my pink angel. I promise you'll never be forgotten. I'll make sure your gravestone is pink." - Her mother Yifat

# Inbar Haiman

![Inbar Haiman](${inbarHaimanPortrait})
*Inbar "Pink" Haiman, 27, graffiti artist and combat soldier*

## The Pink Angel

In the graffiti world, she was known as "Pink" - for her favorite color and her optimistic worldview. The pink of blossoms and youth, of love and affection.

Inbar Haiman grew up in Petah Tikva and started creating street art at 15. She studied visual communications at the University of Haifa, specializing in video art and motion design - just days away from her final year. She planned to open an art studio with her boyfriend Noam.

But before she was an artist, she was a soldier. After high school, she enlisted as a combat soldier in the IDF's Caracal Battalion and served as a commander for three years. During one mission, a grenade exploded near her - she didn't tell her parents so they wouldn't worry.

## October 7, 2023

Inbar was at the Nova festival as a "helper" - volunteering to assist partygoers in distress. When Hamas attacked, she hid under the main stage, then tried to escape.

Along the way, she helped a woman who couldn't run fast enough. Terrorists on a motorcycle caught up. Inbar refused to be taken captive.

She fought back "like a lioness."

They shot her.

Witnesses hiding nearby saw terrorists with bloody hands place her body on a motorcycle and drive toward Gaza.

## The Last Female Hostage

Her family initially believed she was alive. On December 16, 2023, her death was confirmed.

Her body was the last female hostage held in Gaza. She was returned October 15, 2025.

Thousands attended her funeral, many wearing pink. Maccabi Haifa fans came in team jerseys - she was a devoted supporter. Her mother promised: "I'll make sure your gravestone is pink."

Her father: "I'm so sorry I wasn't there to save you, and that it took us so long to bring you home."

Her brother Ido: "You were the family's sunflower - so colorful, so full of life. You taught me graffiti; because of you, I dare to create."

## Her Legacy

After October 7, Israeli graffiti artists painted "Free Pink" across the country. International collectives spread her image abroad. Memorial murals appeared with messages like "RIP Pink: Rest in Paint."

One of her last graffiti tags was salvaged from a steel plate in Haifa and given to her family.

Her great-grandmother was a Holocaust survivor. Her aunt said: "Eighty years ago, we were promised 'never again,' and we got it a second time."

*The family's sunflower, so colorful, so full of life. May her memory be a blessing.*

[Read more](https://www.timesofisrael.com/inbar-haiman-27-graffiti-artist-design-student-was-sweet-and-funny/)
`
};
